import { render, staticRenderFns } from "./Cert_arch.vue?vue&type=template&id=161e1c87&scoped=true"
import script from "./Cert_arch.vue?vue&type=script&lang=js"
export * from "./Cert_arch.vue?vue&type=script&lang=js"
import style0 from "./Cert_arch.vue?vue&type=style&index=0&id=161e1c87&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161e1c87",
  null
  
)

/* custom blocks */
import block0 from "./Cert_arch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports